import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../lang";

export default function Footer({ onBook }) {
  const { t } = useLang();
  return (
    <footer className="border-t border-edge/60 px-6 pb-12 pt-32 md:px-10 md:pt-48" data-testid="site-footer">
      <button
        onClick={onBook}
        data-testid="footer-booking-btn"
        className="group mb-24 block text-left"
      >
        <span className="font-display text-[12vw] font-semibold uppercase leading-[0.9] tracking-tighter text-foreground transition-colors duration-300 group-hover:text-signal md:text-[8vw]">
          {t.footer.big}
        </span>
        <span className="mt-6 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors duration-200 group-hover:text-foreground">
          {t.footer.cta}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </button>

      <div className="grid grid-cols-1 gap-10 border-t border-edge/60 pt-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-display text-lg font-semibold tracking-tight">
            TERRAIN<span className="text-signal">®</span>
          </p>
          <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            {t.footer.cities}
          </p>
        </div>
        <div className="md:col-span-4">
          <button
            type="button"
            onClick={onBook}
            data-testid="footer-contact-link"
            className="font-mono text-sm text-muted-foreground transition-colors duration-200 hover:text-signal"
          >
            {t.footer.contact}
          </button>
        </div>
        <div className="flex items-start justify-between md:col-span-3 md:justify-end md:gap-8">
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground/60 transition-colors duration-200 hover:text-foreground"
          >
            {t.footer.admin}
          </Link>
        </div>
      </div>
      <p className="mt-12 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground/50">
        {t.footer.rights}
      </p>
    </footer>
  );
}
